export default "__VITE_ASSET__547836bf__"